import script from "./AlbumsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlbumsList.vue?vue&type=script&setup=true&lang=ts"

import "./AlbumsList.vue?vue&type=style&index=0&id=40ef3c2d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40ef3c2d"]])

export default __exports__